import styles from './CreateTour.module.css';
import { Route, Switch, useRouteMatch } from "react-router-dom";
import CreateTourSidebar from './../../components/create-tour-sidebar/CreateTourSidebar';
import CreateTourInfo from './../../components/create-tour-info/CreateTourInfo';
import CreateScene from '../create-scene/CreateScene';
import { useEffect } from 'react';
import { setTourActiveSceneIndexSelector } from '../../hooks/store/setters';
import { useAppStore } from '../../hooks/store/useAppStore';

const CreateTour = () => {
   
      const setTourActiveSceneIndex = useAppStore(setTourActiveSceneIndexSelector);

      let { path } = useRouteMatch();
   
      
      useEffect(() => {
        return () => {
            setTourActiveSceneIndex(null);
        }

      },[ setTourActiveSceneIndex ])
    

    return (
        <div className={styles.createTourContainer}>
            <CreateTourSidebar />
            
            <section className={styles.createTourBody}>
                <Switch>
                    <Route path={`${path}/tour-info`} component={CreateTourInfo} />
                    <Route path={`${path}/create-scene`} component={CreateScene} />
                </Switch>
            </section>
        </div>
    );
};

export default CreateTour;